var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.pData.applications),function(app){return _c('li',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.fitment(app))}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }